// Shared state of physical painting, so background GPU work (brush previews)
// waits while the user is painting. Set by PhysicalPaintSystem.
export const paintActivity = {
  // A stroke is in progress.
  active: false,
  // performance.now() of the latest stroke input.
  lastStroke: 0,
};
